'use strict';

(function () {

  var INTERVAL_MS = 3000; /* must match the countdown line animation in collection-redesign.css */
  var initialized = new WeakSet();

  function initCard(card) {
    if (initialized.has(card)) return;
    initialized.add(card);

    var imgs    = Array.from(card.querySelectorAll('.product-card__img'));
    var mediaEl = card.querySelector('.product-card__media');

    if (imgs.length <= 1) return;

    /* Expose the real interval to CSS so the progress-line animation
       duration can never drift out of sync with the actual image switch. */
    card.style.setProperty('--pcard-interval', INTERVAL_MS + 'ms');

    var current = 0;

    if (!imgs[0].classList.contains('is-active')) {
      imgs[0].classList.add('is-active');
    }

    function setActive(index) {
      imgs[current].classList.remove('is-active');
      current = ((index % imgs.length) + imgs.length) % imgs.length;
      imgs[current].classList.add('is-active');
    }

    /* ── Desktop hover — switch immediately, then cycle every INTERVAL_MS,
       looping through all images while hovered; reset instantly on leave ── */
    var cycleTimer = null;

    function startCycle() {
      setActive(current + 1);
      cycleTimer = setInterval(function () {
        setActive(current + 1);
      }, INTERVAL_MS);
    }

    function stopCycle() {
      clearInterval(cycleTimer);
      cycleTimer = null;
    }

    card.addEventListener('mouseenter', startCycle);

    card.addEventListener('mouseleave', function () {
      stopCycle();
      setActive(0);
    });

    /* ── Mobile touch swipe ── */
    if (!mediaEl) return;

    var touchStartX   = 0;
    var touchStartY   = 0;
    var swipeOccurred = false;

    mediaEl.addEventListener('touchstart', function (e) {
      touchStartX   = e.touches[0].clientX;
      touchStartY   = e.touches[0].clientY;
      swipeOccurred = false;
    }, { passive: true });

    mediaEl.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        e.preventDefault();
        swipeOccurred = true;
      }
    }, { passive: false });

    mediaEl.addEventListener('touchend', function (e) {
      if (!swipeOccurred) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (dx < -40) setActive(current + 1);
      else if (dx > 40) setActive(current - 1);
    });

    /* Prevent link navigation when a swipe occurred — tap still navigates */
    mediaEl.addEventListener('click', function (e) {
      if (swipeOccurred) {
        e.preventDefault();
        e.stopPropagation();
        swipeOccurred = false;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-card-hover]').forEach(initCard);
  }

  /* ── Watch for AJAX-injected cards (product-recommendations lazy load) ── */
  function observeRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (container) {
      var observer = new MutationObserver(function () {
        container.querySelectorAll('[data-card-hover]').forEach(initCard);
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observeRecommendations();
    });
  } else {
    init();
    observeRecommendations();
  }

  window.HeritageCardHover = { initAll: init };
  window.HeritageCardGallery = window.HeritageCardGallery || {};
  window.HeritageCardGallery.initAllHover = init;

})();
